import { Accordion, AccordionDetails, AccordionSummary, Button, Container, CssBaseline, Grid, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import TitleName from "src/components/title-name";
import { Styles } from "src/styles/material-styles";
import PropTypes from "prop-types"
import { PapiroConsole } from "src/utils/papiroConsole";
import Api from "src/services/api";
import { DataGrid, GridToolbarFilterButton } from "@mui/x-data-grid";
import { Add, Delete, ExpandMore } from "@mui/icons-material";
import DialogConfirmation from '../../../components/dialog-confirmation'
import DialogAddMultiple from '../../../components/dialog-add-multiple'
import SimpleCheckBox from "src/components/checkbox/check";

function CreateCalledStep(props) {

    const { classes, intl, backButton, nextButton, clientPortal, handleNextBarProgress, handleComplete, setLoading, setClientPortal } = props

    const NoDataRows = () => {
        return (
            <div className="MuiDataGrid-window" style={{ display: 'flex', justifyContent: 'center', top: 56, overflowY: 'auto' }} >{intl.formatMessage({ id: "rows.show" })}</div>
        )
    }

    const [item, setItem] = useState({
        id: clientPortal.id,
        enablecreatecalled: clientPortal.enablecreatecalled,
        createcalledpagetitle: clientPortal.createcalledpagetitle,
        createcalledpagetext: clientPortal.createcalledpagetext,
        calledservicesettingslist: clientPortal.calledservicesettingsclientportals ? clientPortal.calledservicesettingsclientportals.map(csscp => {
            if (csscp.calledservicesettings) {
                return ({
                    id: csscp.calledservicesettings.id,
                    name: csscp.calledservicesettings.title
                })
            }
        }) : [],
    })

    const [options, setOptions] = useState([])
    const [optionsForSelect, setOptionsForSelect] = useState(clientPortal.calledservicesettingslist)
    const [optionsForDelete, setOptionsForDelete] = useState([])
    const [optionsSelected, setOptionsSelected] = useState(false)
    const [selectModalOpen, setSelectModalOpen] = useState(false)

    const updateClientPortal = (newitem) => {
        setClientPortal({
            ...clientPortal,
            enablecreatecalled: newitem.enablecreatecalled,
            createcalledpagetitle: newitem.createcalledpagetitle,
            createcalledpagetext: newitem.createcalledpagetext,
            calledservicesettingsclientportals: newitem.calledservicesettingslist.map(csscp => {
                return ({
                    calledservicesettings: {
                        id: csscp.id,
                        title: csscp.name
                    }
                })
            })
        })
    }

    useEffect(() => {
        const initializeData = async () => {
            const newItem = {
                id: clientPortal.id,
                enablecreatecalled: clientPortal.enablecreatecalled,
                createcalledpagetitle: clientPortal.createcalledpagetitle,
                createcalledpagetext: clientPortal.createcalledpagetext,
                calledservicesettingslist: clientPortal.calledservicesettingsclientportals ? clientPortal.calledservicesettingsclientportals.map(csscp => {
                    if (csscp.calledservicesettings) {
                        return ({
                            id: csscp.calledservicesettings.id,
                            name: csscp.calledservicesettings.title
                        })
                    }
                }) : [],
            }
            await getOptions(newItem.calledservicesettingslist)
            await setItem(newItem)
        }
        initializeData()
    }, [clientPortal])

    const getOptions = async (calledservicesettingslist) => {
        setLoading(true)

        await Api.get(`calledservicesettings/allbyhirer/${clientPortal.hirerid}`)
            .then(async (result) => {
                if (result.data.success) {
                    let resultoptions = []
                    result.data.data.map(item => {
                        if (!calledservicesettingslist.find(i => i.id == item.id)) {
                            resultoptions.push({ id: item.id, name: item.title })
                        }
                    })
                    await setOptions(resultoptions)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false)
                setNotification(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
            })
    }

    const deleteOptionsForDelete = async () => {

        if (optionsForDelete.length > 0) {

            setLoading(true)

            let data = new FormData()
            var calledservicesettingsid = optionsForDelete.join(',')

            data.append("calledservicesettingsid", calledservicesettingsid)
            data.append("clientportalid", item.id)

            await Api.post("calledservicesettingsclientportal/delete", data)
                .then(result => {
                    if (result.data.success) {
                        var response = []
                        var newoptions = options
                        item.calledservicesettingslist.map(css => {
                            var optionselected = result.data.data.find(r => r.calledservicesettingsid == css.id)
                            if (optionselected) {
                                response.push(css)
                            } else {
                                newoptions.push(css)
                            }
                        })
                        setItem({ ...item, calledservicesettingslist: response })
                        setOptionsForSelect([])
                        setLoading(false)
                        setNotification(true, 'success', intl.formatMessage({ id: "add.success" }))
                        updateClientPortal({ ...item, calledservicesettingslist: response })
                    }
                    else {
                        setLoading(false)
                        setNotification(true, 'error', result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }))
                        Api.kickoff(result)
                    }
                })
                .catch(err => {
                    setLoading(false)
                    setNotification(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
                })
        } else {
            setNotification(true, 'error', intl.formatMessage({ id: "called.service.select.settings" }))
        }
    }

    const saveOptions = async () => {
        setLoading(true)

        if (!!!optionsForSelect || optionsForSelect?.length == 0) {
            setLoading(false)
            setNotification(true, 'error', intl.formatMessage({ id: "called.service.select.settings" }))
            return
        }

        let data = new FormData()

        var calledservicesettingsid = ''
        optionsForSelect.map(i => {
            calledservicesettingsid += i.id + ','
        })

        data.append("calledservicesettingsid", calledservicesettingsid)
        data.append("clientportalid", item.id)

        await Api.post("calledservicesettingsclientportal/multiple", data)
            .then(result => {
                if (result.data.success) {
                    let response = []
                    let newoptions = options
                    result.data.data.map(r => {
                        var optionselected = options.find(o => o.id == r.calledservicesettingsid)
                        if (optionselected) {
                            response.push(optionselected)
                            newoptions = newoptions.filter(no => no.id != optionselected.id)
                        }
                    })
                    setItem({ ...item, calledservicesettingslist: [...item.calledservicesettingslist, ...response] })
                    setOptionsForSelect([])
                    setOptions(newoptions)
                    setLoading(false)
                    setNotification(true, 'success', intl.formatMessage({ id: "add.success" }))
                    updateClientPortal({ ...item, calledservicesettingslist: [...item.calledservicesettingslist, ...response] })
                }
                else {
                    setLoading(false)
                    setNotification(true, 'error', result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }))
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                PapiroConsole.log(err)
                setLoading(false)
                setNotification(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
            })

        setSelectModalOpen(false)
    }

    const changeValues = (stateName, value, text = '') => {

        if (stateName === 'optionsForSelect') {
            setOptionsForSelect(value)
        }
        else if (stateName === 'optionsSelected') {
            if (value == true) {
                setOptionsForSelect(options)
            } else {
                setOptionsForSelect([])
            }
        }
    }

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        setItem({
            ...item,
            [name]: value
        })
    }

    const handleChangeSelect = (stateName, value) => {
        setItem({
            ...item,
            [stateName]: value
        })
    }

    const setNotification = (openNotification, notificationVariant, notificationMessage) => {
        props.setNotification({ openNotification: openNotification, notificationVariant: notificationVariant, notificationMessage: notificationMessage })
    }

    const handleCloseDialogAddMultiple = () => {
        setSelectModalOpen(false)
        setOptionsForSelect([])
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        let data = new FormData()
        data.append('id', clientPortal.id)
        data.append('enablecreatecalled', item.enablecreatecalled)
        data.append('createcalledpagetitle', item.createcalledpagetitle)
        data.append('createcalledpagetext', item.createcalledpagetext)

        let config = {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }

        await Api.put("/clientportal/createcalled", data, config)
            .then(result => {
                if (result.data.success) {
                    updateClientPortal(item)
                    setLoading(false)
                    handleNextBarProgress()
                    handleComplete()
                }
                else {
                    setLoading(false)
                    setNotification(true, 'error', result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" }))
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                setLoading(false)
                setNotification(true, 'error', err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }))
            })
    }

    return (
        <div className={classes.root}>
            <Container>
                <CssBaseline />
                <div className={classes.paper} style={{ marginTop: '12px' }}>
                    <h4 className="h4-title" style={{ marginTop: 0, marginBottom: 0 }}>
                        {<FormattedMessage id="called.creation" />}
                        <TitleName />
                    </h4>
                    <form name='myForm' className={classes.form} onSubmit={handleSubmit} encType='multipart/form-data'>
                        <Grid container spacing={2}>
                            <Grid item xs={10} sm={12}>
                                <SimpleCheckBox label={intl.formatMessage({ id: "enable.called.creation" })} name='enablecreatecalled' stateName='enablecreatecalled' changeSelect={handleChangeSelect} selected={item.enablecreatecalled} />
                            </Grid>
                            <Grid item xs={12} sm={12} disabled={!item.enablecreatecalled}>
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>{intl.formatMessage({ id: "menu.called.service.settings" })}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container item xs={12} sm={12} >
                                            <Grid item xs={12} sm={12} style={{ margin: '5px', padding: 10, display: 'flex', flexDirection: 'row', backgroundColor: '#eee' }} >
                                                <Grid item xs={12} sm={4} >
                                                </Grid>
                                                <Grid item xs={12} sm={4} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
                                                    <DialogConfirmation
                                                        msgButton={"Remover formulário"}
                                                        msg={"Você tem certeza que desejar remover este formulário deste portal?"}
                                                        msgDisagree={intl.formatMessage({ id: "cancel" })}
                                                        msgAgree={intl.formatMessage({ id: "yes" })}
                                                        handleConfirmation={e => deleteOptionsForDelete()}
                                                        classes={classes}
                                                        icon={<Delete />}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        fullWidth
                                                        className={classes.button}
                                                        startIcon={<Add />}
                                                        onClick={e => setSelectModalOpen(true)} >
                                                        {intl.formatMessage({ id: "add" })}
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12}
                                                style={{
                                                    border: '3px solid #eee'
                                                }} >
                                                <div style={{ height: 350 }}>
                                                    <DataGrid
                                                        style={{ fontSize: 14, color: '#000' }}
                                                        className="DataGridStyle"
                                                        components={{
                                                            NoRowsOverlay: NoDataRows,
                                                            Toolbar: GridToolbarFilterButton,
                                                        }}
                                                        rows={item.calledservicesettingslist}
                                                        rowsPerPageOptions={[5]}
                                                        checkboxSelection
                                                        onSelectionModelChange={itm => {
                                                            if (itm.length > 0) {
                                                                setOptionsForDelete(itm)
                                                            } else {
                                                                setOptionsForDelete([])
                                                            }
                                                        }}
                                                        columns={[
                                                            { headerName: intl.formatMessage({ id: "title" }), field: 'name', width: 500 },
                                                        ]}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <TextField fullWidth label={intl.formatMessage({ id: "create.called.page.title" })} name="createcalledpagetitle" value={item.createcalledpagetitle} onChange={handleChange} />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <TextField fullWidth label={intl.formatMessage({ id: "create.called.page.text" })} name="createcalledpagetext" value={item.createcalledpagetext} onChange={handleChange} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} style={{ marginBottom: '60px', display: 'flex', marginTop: '20px' }}>
                            <Grid item xs={12} sm={2} >
                                {backButton}
                            </Grid>
                            <Grid item xs={12} sm={2} >
                                {nextButton}
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginLeft: 'auto' }}>
                                <Button
                                    type='submit'
                                    fullWidth
                                    variant='contained'
                                    color='primary'
                                >
                                    {<FormattedMessage id="save.next" />}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
                <DialogAddMultiple
                    title={intl.formatMessage({ id: "new.form" })}
                    selected={optionsForSelect}
                    options={options}
                    checked={optionsSelected}
                    changeValues={changeValues}
                    open={selectModalOpen}
                    close={handleCloseDialogAddMultiple}
                    save={saveOptions}
                    intl={intl}
                    checkboxLabel={intl.formatMessage({ id: "select.all.forms" })}
                    checkboxStateName='optionsSelected'
                    autoCompleteLabel={intl.formatMessage({ id: "menu.called.service.settings" })}
                    autoCompleteStateName="optionsForSelect"
                />
            </Container>
        </div>
    )
}

CreateCalledStep.propTypes = {
    classes: PropTypes.object.isRequired,
    back: PropTypes.func,
    next: PropTypes.func
};
const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,

});
export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(CreateCalledStep)));